import { Campaign, AdGroup, ResponsiveAd, ResponsiveSearchAd, DynamicSearchAd } from '@bingads-webui/campaign-odata-schemas';
import { isBulkWrappedResponse } from '../shared/bulk';
import { ERROR_ENTITY, getBulkUploadErrorType, modelToViewModelForBulkErrors, removeReferencedEntityInvalidIdErrors } from '../shared/bulk-upsert-errors';
import { GENERIC_ERROR_MESSAGE_KEY } from '../shared/constants';
import { saveAd as saveDSA, deleteAd as deleteDSA } from './dynamic-search-ad-bulk';
import { saveAd as saveRSA, deleteAd as deleteRSA } from './responsive-search-ad-bulk';
import { saveAd as saveMMA, deleteAd as deleteMMA } from './multimedia-ad-bulk';

const bulkUpsertAdEntityErrorMap = {
  [getBulkUploadErrorType(Campaign)]: ERROR_ENTITY.Campaign,
  [getBulkUploadErrorType(AdGroup)]: ERROR_ENTITY.AdGroup,
  [getBulkUploadErrorType(DynamicSearchAd)]: ERROR_ENTITY.DynamicSearchAd,
  [getBulkUploadErrorType(ResponsiveAd)]: ERROR_ENTITY.ResponsiveAd,
  [getBulkUploadErrorType(ResponsiveSearchAd)]: ERROR_ENTITY.ResponsiveSearchAd,
};

const saveAdFuncs = {
  DynamicSearch: saveDSA,
  ResponsiveSearch: saveRSA,
  Responsive: saveMMA,
};

const deleteAdFuncs = {
  DynamicSearch: deleteDSA,
  ResponsiveSearch: deleteRSA,
  Responsive: deleteMMA,
};

export const saveAd = ({
  ad,
  adType,
  campaignId,
  adGroupId,
  cid,
  aid,
}, options) => {
  const saveAdFunc = saveAdFuncs[adType];
  if (saveAdFunc) {
    return saveAdFunc({
      ad,
      campaignId,
      adGroupId,
      cid,
      aid,
    }, options);
  }
  return Promise.reject(new Error(`Unsupported ad type: ${adType}`));
};

export const deleteAd = ({
  adId,
  adType,
  adGroupId,
}, {
  i18n,
  scenario,
  activityLogger,
}) => {
  const deleteAdFunc = deleteAdFuncs[adType];
  if (deleteAdFunc) {
    return deleteAdFunc(adId, {
      parentId: adGroupId,
    })
      // with bulk the result will have shape of:
      // - { ...entityData } - in case of success;
      // - { entity: { ...entityData }, errors: [(EditorialError|MTError)] } - in case of error(s).
      .then(result => ({
        data: result,
      }), (bulkOrSystemError) => {
        if (isBulkWrappedResponse(bulkOrSystemError)) {
          const { entity, errors } = bulkOrSystemError;

          let filteredErrors = errors;
          if (entity.Id <= 0) {
            filteredErrors = removeReferencedEntityInvalidIdErrors(errors);
          }

          const serverErrors = modelToViewModelForBulkErrors(
            filteredErrors,
            bulkUpsertAdEntityErrorMap,
            scenario,
            i18n,
            activityLogger
          );

          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject({
            serverErrors,
          });
        }

        // Activity
        // eslint-disable-next-line no-console
        console.warn(`Campaign bulk upsert system error: ${bulkOrSystemError.stack || bulkOrSystemError.message || bulkOrSystemError}`);
        // eslint-disable-next-line prefer-promise-reject-errors
        return {
          systemErrors: [i18n.getString(GENERIC_ERROR_MESSAGE_KEY)],
        };
      });
  }
  return Promise.reject(new Error(`Unsupported ad type: ${adType}`));
};
